import Vue from 'vue'
import Router from 'vue-router'
import layout from './views/layout/layout.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
            {
                path: '/',
                name: 'home',
                component: layout,
                meta: {
                    title: 'layout布局',
                    breadcrumb: [
                        {name: 'Hello World'}
                    ]
                },
                children: [
                  {
                      path: '/article',
                      name: 'article',
                      component: () => import('./views/ArticleListPage.vue'),
                      meta: {
                          title: 'article',
                          breadcrumb: [
                              {name: '文章管理' ,link:'article'},
                              {name: '文章列表'}
                        ]
                      }
                  },
                  {
                    path: '/creatArticle',
                    name: 'creatArticle',
                    component: () => import('./views/CreatArticlePage.vue'),
                    meta: {
                      title: 'creatArticle',
                      breadcrumb: [
                        {name: '文章管理',link:'article'},
                        {name: '创建文章'}
                      ]
                    }
                  },
                  {
                    path: '/articleDetail/:id',
                    name: 'articleDetail',
                    component: () => import('./views/CreatArticlePage.vue'),
                    meta: {
                      title: 'articleDetail',
                      breadcrumb: [
                        {name: '文章管理',link:'article'},
                        {name: '文章详情'}
                      ]
                    }
                  },
                  {
                    path: '/category',
                    name: 'category',
                    component: () => import('./views/CategoryListPage.vue'),
                    meta: {
                      title: 'category',
                      breadcrumb: [
                        {name: '文章管理',link:'article'},
                        {name: '文章类型'}
                      ]
                    }
                  },
                  {
                    path: '/creatCategory',
                    name: 'creatCategory',
                    component: () => import('./views/CreatCategoryPage.vue'),
                    meta: {
                      title: 'category',
                      breadcrumb: [
                        {name: '文章管理',link:'article'},
                        {name: '添加类型'}
                      ]
                    }
                  },
                  {
                    path: '/categoryDetail/:id',
                    name: 'creatCategory',
                    component: () => import('./views/CreatCategoryPage.vue'),
                    meta: {
                      title: 'category',
                      breadcrumb: [
                        {name: '文章管理',link:'article'},
                        {name: '添加类型'}
                      ]
                    }
                  },
                ]

            },
            {
                path: '/login',
                name: 'login',
                component: () => import('./views/LoginPage.vue'),
                meta: {
                    title: '登录'
                }
            },
            {
                path: '/register',
                name: 'register',
                component: () => import('./views/RegisterPage.vue'),
                meta: {
                    title: '注册',
                    breadcrumb: 'register'
                }
            }
        ]
})
